module.exports = __webpack_public_path__ + "static/img/openscreen.b3d136e8.svg";